import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserRoutes } from './user.routing';
import { ShareModule } from '../share/share.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/core/material.module';
import { UserManagementComponent } from './user-management/user-management.component';

@NgModule({
  declarations: [
    UserManagementComponent
  ],
  imports: [
    CommonModule,
    ShareModule,
     UserRoutes,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule

  ],
})
export class UserModule { }
